import type { DashboardDailyPoint } from '@pb26/shared';

export function MiniBarChart({
  title,
  subtitle,
  data,
  color = '#a855f7',
}: {
  title: string;
  subtitle?: string;
  data: DashboardDailyPoint[];
  color?: string;
}) {
  const max = Math.max(1, ...data.map((d) => d.value));
  const total = data.reduce((sum, d) => sum + d.value, 0);
  const barWidth = 100 / data.length;

  return (
    <div className="pb-chart-card pb-glow-card">
      <div className="pb-chart-card__head">
        <div className="pb-chart-card__title">{title}</div>
        {subtitle && <div className="pb-chart-card__subtitle">{subtitle}</div>}
        <div className="pb-chart-card__total">Σ {total} за 30 дней</div>
      </div>
      <svg
        className="pb-chart-card__svg"
        viewBox="0 0 100 40"
        preserveAspectRatio="none"
        role="img"
        aria-label={title}
      >
        {data.map((point, i) => {
          const h = (point.value / max) * 34;
          return (
            <rect
              key={point.date}
              x={i * barWidth + barWidth * 0.15}
              y={38 - h}
              width={barWidth * 0.7}
              height={Math.max(h, point.value > 0 ? 0.8 : 0)}
              rx={0.6}
              fill={color}
              opacity={point.value > 0 ? 0.85 : 0.15}
            >
              <title>{`${point.label}: ${point.value}`}</title>
            </rect>
          );
        })}
      </svg>
      <div className="pb-chart-card__axis">
        <span>{data[0]?.label}</span>
        <span>{data[Math.floor(data.length / 2)]?.label}</span>
        <span>{data[data.length - 1]?.label}</span>
      </div>
    </div>
  );
}
